import Chip from '../../../shared/components/Chip/Chip';
import { getSearchEntityBadgeVariant, getSearchEntityIcon, getSearchEntityLabel } from '../models/globalSearchModel';
import { getSearchMetadataLine } from '../utils/globalSearchFormatters';
import SearchHighlight from './SearchHighlight';
import '../styles/global-search-validation.scss';

export default function GlobalSearchResult({ result, query, active, id, onSelect, option = true }) {
  const Icon = getSearchEntityIcon(result.entityType);
  const metadata = getSearchMetadataLine(result);
  return <button
    id={id}
    type="button"
    role={option ? 'option' : undefined}
    aria-selected={option ? Boolean(active) : undefined}
    className={`global-search-result${active ? ' is-active' : ''}`}
    onMouseDown={(event) => event.preventDefault()}
    onClick={() => onSelect(result)}
  >
    <span className="global-search-result__icon"><Icon fontSize="small" /></span>
    <span className="global-search-result__body">
      <span className="global-search-result__top">
        <Chip size="small" color={getSearchEntityBadgeVariant(result.entityType)} label={result.badges?.[0]?.label || getSearchEntityLabel(result.entityType)} />
        <strong><SearchHighlight text={result.title} query={query} /></strong>
      </span>
      {result.subtitle && <span className="global-search-result__subtitle"><SearchHighlight text={result.subtitle} query={query} /></span>}
      {result.description && <span className="global-search-result__description"><SearchHighlight text={result.description} query={query} /></span>}
      {metadata && <span className="global-search-result__meta">{metadata}</span>}
    </span>
  </button>;
}
